import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyCashFundPurchaseConfirmationWrapper = loadable(
  () => import(/* webpackChunkName: "content/cashfunds/purchase-confirmation" */ './CashFundPurchaseConfirmationWrapper'),
);
